import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, requiredPayloadEnvelope } from '../envelope.js';
import { realtimeNegotiateSchema } from '../common/schemas.js';
import { overlayKindSchema } from '../overlay/kinds.js';
import { overlayRuntimeStatusSnapshotSchema } from '../overlay/overlay-runtime-status.schema.js';
import { overlayTokenCommandSchema, overlayTokenIssueBodySchema, overlayTokenRegenerateBodySchema, overlayTokenRevokeBodySchema, } from '../overlay/overlay-token.schema.js';
const c = initContract();
const kindPathParams = z.object({ kind: overlayKindSchema });
/** user-api — 로그인(AT+DPoP) 필요. 능력 토큰 발급·재발급·폐기. */
export const userOverlaysContract = c.router({
    issueToken: {
        method: 'POST',
        path: '/overlays/:kind/token',
        pathParams: kindPathParams,
        body: overlayTokenIssueBodySchema,
        responses: {
            200: requiredPayloadEnvelope(overlayTokenCommandSchema),
            201: requiredPayloadEnvelope(overlayTokenCommandSchema),
            ...commonErrorResponses,
        },
    },
    regenerateToken: {
        method: 'POST',
        path: '/overlays/:kind/token/regenerate',
        pathParams: kindPathParams,
        body: overlayTokenRegenerateBodySchema,
        responses: {
            200: requiredPayloadEnvelope(overlayTokenCommandSchema),
            ...commonErrorResponses,
        },
    },
    revokeToken: {
        method: 'POST',
        path: '/overlays/:kind/token/revoke',
        pathParams: kindPathParams,
        body: overlayTokenRevokeBodySchema,
        responses: {
            200: requiredPayloadEnvelope(overlayTokenCommandSchema),
            ...commonErrorResponses,
        },
    },
    /**
     * 본인 오버레이 실시간 채널을 읽기 전용으로 모니터링할 Client Access URL 발급.
     * overlay-web과 같은 그룹(`overlays` 허브, `user:{userId}:kind:{kind}`)에 join만 가능하고 발행 권한은 없다.
     */
    negotiateMonitor: {
        method: 'GET',
        path: '/overlays/:kind/negotiate',
        pathParams: kindPathParams,
        responses: {
            200: requiredPayloadEnvelope(realtimeNegotiateSchema),
            ...commonErrorResponses,
        },
    },
    /**
     * 로그인 사용자가 자기 오버레이의 집계 snapshot을 읽는다.
     * 능력 토큰을 쓰지 않는다. 콘솔 AT+DPoP만 허용한다.
     */
    runtimeStatus: {
        method: 'GET',
        path: '/overlays/:kind/runtime-status',
        pathParams: kindPathParams,
        responses: {
            200: requiredPayloadEnvelope(overlayRuntimeStatusSnapshotSchema),
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=overlays.contract.js.map